export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_54-f39ddc5c36cd2cde0b080f8853d88961.jpg";